import React from 'react';
import './styles.scss';
import classNames from 'classnames';
import RadioButton from 'components/Inputs/RadioButton';

interface Props {
  description: string;
  icon: React.ReactElement;
  id: string;
  selected?: boolean;
  title: string;
  onChange: any;
}

const ExportFileTypeCard: React.FC<Props> = ({
  description,
  icon,
  id,
  selected = false,
  title,
  onChange,
}) => {
  const mainClass = classNames({
    'export-file-type-card': true,
    selected: selected,
  });

  return (
    <div
      className={mainClass}
      onClick={(event) => {
        event.preventDefault();
        onChange(id);
      }}
    >
      <div className="radio-button-container">
        <RadioButton
          value={selected ? 1 : null}
          options={[{ id: 1, label: '' }]}
          onChange={onChange}
        />
      </div>
      <div className="main-container">
        <div className="image">{icon}</div>
        <div className="text">
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
      </div>
    </div>
  );
};

export default ExportFileTypeCard;
